import { Box } from '@montugroup/design-system';
import { skeletonClasses, styled } from '@mui/material';

export const PageContent = styled(Box)(({ theme }) => ({
  gap: theme.spacing(5),
  alignSelf: 'stretch',
  display: 'grid',
  paddingBottom: 0,
  gridTemplateColumns: '1fr',
  gridTemplateAreas: `
      "steps"
      "title"    
      "products"
      "purchase"`,
  [`${theme.breakpoints.up('lg')}`]: {
    gridTemplateColumns: 'repeat(10, 1fr)', // 12 grid, with the outermost column on either side as mandatory page margin
    gridTemplateAreas: `"steps steps steps steps steps steps steps steps steps steps"
      "title title title title title title title title title title"
       "products products products products products products products purchase purchase purchase"`,
  },
  width: 'inherit',
  [`${theme.breakpoints.up('sm')}`]: {
    paddingBottom: theme.spacing(18),
  },
}));

export const PageSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  '&:empty': {
    margin: 0,
  },
  [`& .${skeletonClasses.root}`]: {
    marginBottom: theme.spacing(4),
    height: theme.spacing(16),
  },
}));

export const DesktopOnly = styled(Box)(({ theme }) => ({
  display: 'none',
  position: 'relative',
  [`${theme.breakpoints.up('lg')}`]: {
    display: 'flex',
  },
}));

export const MobileOnlySticky = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(5),
  gap: theme.spacing(6),
  zIndex: theme.zIndex.drawer,
  background: 'white',
  boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)',
  '& > *': {
    flex: 1,
  },
  [`${theme.breakpoints.up('md')}`]: {
    left: 'var(--sidebar-width, DRAWER_WIDTH)',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  [`${theme.breakpoints.up('lg')}`]: {
    display: 'none',
  },
}));

export const DisclaimerRRP = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(2)} 0`,
  marginBottom: theme.spacing(10),
  [`${theme.breakpoints.up('lg')}`]: {
    marginBottom: '0',
  },
}));
